<template>
  <div class="editor-main">
    <div v-show="!currentInfo.operation">
      <!-- 简历头信息 -->
      <div class="edit-model edit-user">
        <div class="user-info" v-if="profile.email || profile.phone" @click="editProfile">
          <div class="user-name">
            <span>{{profile.username || '姓名'}}</span>
          </div>
          <div class="user-info-item" v-if="profile.phone">电话：{{profile.phone}}</div>
          <div class="user-info-item" v-if="profile.email">邮箱：{{profile.email}}</div>
          <div class="user-info-item" v-if="profile.address">地址：{{profile.address}}</div>
          <div class="user-info-item" v-if="profile.homepage">个人网站：{{profile.homepage}}</div>
          <div class="user-info-item" v-if="profile.wechat">微信：{{profile.wechat}}</div>
          <div class="user-info-item" v-if="profile.linked_in">linkedin：{{profile.linked_in}}</div>
          <div class="user-info-item" v-if="profile.birthday">
            <span>{{profile.format_pref && profile.format_pref.age_birthday.chosen === 'age' ? '年龄：' : '生日：'}}</span>
            {{ profile.format_pref && profile.format_pref.age_birthday.chosen === 'age' ?
            moment().diff(profile.birthday, 'year') : moment(profile.birthday).format('YYYY-MM') }}
            <span
                v-if="profile.format_pref && profile.format_pref.age_birthday.chosen === 'age' && cvLang === 'cn'">岁</span>
          </div>
          <div class="user-info-item" v-if="profile.gender">性别：{{profile.gender}}</div>
          <div class="user-info-item" v-if="profile.height">身高：{{profile.height}}</div>
          <div class="user-info-item" v-if="profile.weight">体重：{{profile.weight}}</div>
          <div class="user-info-item" v-if="profile.ethnic">民族：{{profile.ethnic}}</div>
          <div class="user-info-item" v-if="profile.hometown">籍贯：{{profile.hometown}}</div>
          <div class="user-info-item" v-if="profile.marriage">婚姻状况：{{profile.marriage}}</div>
          <div class="user-info-item" v-if="profile.political_status">政治面貌：{{profile.political_status}}</div>
          <div class="user-info-item" v-if="profile.exp_job">求职意向：{{profile.exp_job}}</div>
          <div class="user-info-item" v-if="profile.current_job">工作状态：{{profile.current_job}}</div>
          <div class="user-info-item" v-if="profile.expected_salary">期望薪资：{{profile.expected_salary}}</div>
        </div>
        <div class="user-info" v-else @click="editProfile">
          <div class="user-name">
            <span>{{profile.username || '姓名'}}</span>
            <!-- <i class="iconfont iconedit"></i> -->
          </div>
          <div style="color:#BCBCBC;margin-top: 14px;">请填写您的基本信息</div>
        </div>
        <div :class="['user-picture']">
          <img v-if="profile.avatar_url" :src="profile.avatar_url" alt="">
          <img v-else class="up-img-default" src="https://files.wondercv.com/pcvue/upimg.png" alt="" @click="addAvatar">
          <div class="user-picture-delete" @click.stop v-if="profile.avatar_url">
            <p @click.stop="addAvatar"><i class="iconfont iconedit-"></i>编辑</p>
            <p @click.stop="deleteAvatar"><i class="iconfont icontrash-"></i>删除</p>
          </div>
        </div>
      </div>
      <!-- 校徽 -->
      <div class="module" v-if="cvDetail.basic_info && cvDetail.basic_info.school_logo_url">
        <div class="school-module">
          <div class="school-title">
            <div class="school-name">校徽</div>
            <span class="school-tag">已添加</span>
          </div>
          <div class="school-btn">
            <i class="iconfont iconedit-" @click="editSchool"></i>
            <i class="iconfont icontrash-" @click="deleteSchool"></i>
          </div>
        </div>
      </div>
      <!-- 模块 -->
      <div class="module" v-for="(opt, index) in sectionPosition" :key="index">
        <div class="module-title">
          <div class="module-name">
            <div class="module-name-text text-overflow">{{ getSectionTitle(opt) }}</div>
            <!-- <div class="module-tag"
                 v-if="(opt.type !== 'extras' && getInfosByType(opt) && !getInfosByType(opt).length)">未完成
            </div> -->
          </div>
          <div class="module-btn" @click="editModule({}, opt, 'add')" v-if="showAdd(opt) && !(cvDetail.basic_info.kind === 'template' || cvDetail.basic_info.kind === 'sample')">添加
            <!-- <i class="iconfont iconchevron-right"></i> -->
          </div>
          <div class="module-btn" @click="editModule({}, opt, 'add')" v-else-if="showAdd(opt)"><i class="iconfont iconchevron-right"></i> </div>
        </div>
        <!-- extras -->
        <ul v-if="opt.type === 'extras' && extrasNotEmpty()" @click="editModule(extras, opt, 'edit')">
          <template v-for="(item, index) in extrasPosition">
            <li class="module-item extras-item pr" :key="index" v-if="extras[item] && extras[item].description">
              {{ cvDetail.submodule_info[`${item}_title`]}} {{extras[item] && extras[item].description }}

              <!-- 上下调整顺序按钮 -->
              <div class="module-sort pa clearfix">
                <div class="iconfont iconarrow-up-circle-2 fl color_60" :class="[index===0 ? 'disabled' : null]" @click.stop="index===0 ? null : sortExtrasModule(item, 'up', index)"></div>
                <div class="iconfont iconarrow-down-circle-2 fl color_60" :class="[index===Object.keys(extrasPosition).length-1 ? 'disabled' : null]" @click.stop="index===Object.keys(extrasPosition).length-1 ? null : sortExtrasModule(item, 'down', index)"></div>
              </div>

            </li>
          </template>
        </ul>
        <!-- custom org, work, edu, info -->
        <template v-else-if="getInfosByType(opt) && getInfosByType(opt).length && opt.type !== 'extras'">
          <div class="module-item pr" v-for="(item, index) in getInfosByType(opt)" :key="index" @click="editModule(item, opt, 'edit')">
            <!-- 上下调整顺序按钮 -->
            <div class="module-sort pa clearfix" v-if="getInfosByType(opt).length>1">
              <div class="iconfont iconarrow-up-circle-2 fl color_60" :class="[index===0 ? 'disabled' : null]" @click.stop="index===0 ? null : sortModule(opt, 'up', index)"></div>
              <div class="iconfont iconarrow-down-circle-2 fl color_60" :class="[index===getInfosByType(opt).length-1 ? 'disabled' : null]" @click.stop="index===getInfosByType(opt).length-1 ? null : sortModule(opt, 'down', index)"></div>
            </div>
            <template v-show="opt.type !== 'personal_summary' && opt.type !== 'skill_list'">
              <div class="item-title">
                <div :class="{'text-bold': opt.type !== 'honor'}" class="item-name text-overflow">{{item.company || item.university || item.name}}</div>
              </div>
              <div class="item-info" v-if="opt.type === 'edus'">
                <span v-if="item.city">{{item.city}}</span>
                <span v-if="item.major">{{item.major}}</span>
                <span v-if="item.degree">{{item.degree_id | degree(myself, item.degree)}}</span>
                <span v-if="item.uni_school">{{item.uni_school}}</span>
              </div>
              <div class="item-info" v-if="opt.type === 'works'">
                <span v-if="item.city">{{item.city}}</span>
                <span v-if="item.title">{{item.title}}</span>
                <span v-if="item.dept">{{item.dept}}</span>
              </div>
              <div class="item-info" v-if="opt.type === 'orgs'">
                <span v-if="item.city">{{item.city}}</span>
                <span v-if="item.title">{{item.title}}</span>
                <span v-if="item.dept">{{item.dept}}</span>
              </div>
              <div class="item-info"
                   v-if="opt.type === 'custom' || opt.type === 'project_experience' || opt.type === 'reasearch_experience'">
                <span v-if="item.city">{{item.city}}</span>
                <span v-if="item.title">{{item.title}}</span>
                <span v-if="item.dept">{{item.dept}}</span>
              </div>
              <div class="item-date" v-if='item.start_at || item.end_at || item.present'>
                <span v-if="item.start_at">{{moment(item.start_at).format('YYYY.MM')}}</span>
                <span v-if="item.start_at && (item.end_at || item.present)"> - </span>
                <span v-if="item.end_at">{{moment(item.end_at).format('YYYY.MM')}}</span>
                <span v-if="item.present">{{item.present}}</span>
              </div>
            </template>
            <div class="item-desc-wrapper">
              <div class="item-desc" v-html="item.description" v-if="item.description">
              </div>
              <div class="mask"></div>
            </div>
          </div>
        </template>
        <div class="module-default" v-else @click="editModule({}, opt, 'add')">
          {{placeholder[opt.type]}}
        </div>
      </div>
    </div>
    <edit-module v-if="currentInfo.operation"/>
  </div>
</template>
<script>
	import api from '@/api'
	import moment from 'moment'
	import { mapState, mapMutations, mapActions } from 'vuex'
	import EditModule from './editModule/index'
  import degree from '@/assets/json/degree'

	import { dealCvDataMixin } from '../../../../assets/js/mixins'

  let sortModuleTimeName = null;

	export default {
		name: 'cvsEditor',
		mixins: [ dealCvDataMixin ],
		components: {
			EditModule
		},
		data () {
			return {
        moment,
        myself:this,
				// placeholder: {}
			}
		},
		computed: {
			...mapState('cvsEditor', [ 'cvInfo', 'list', 'editModuleData', 'others' ]),
			...mapState('editor', [ 'cvToken', 'cvDetail', 'currentInfo', 'profile', 'backUpProfile', 'extras' ]),
			...mapState('app', [ 'updateOssOptions' ]),
			...mapState('experience', [ 'sidebarOption', ]),
			isMentorEditor () {
				return window.location.href.includes('mentor')
			}
    },
    watch: {},
    filters:{
      degree(id, myself, degreeName){
        let item = degree.filter(item=>item.id===id);
        let lang = myself.cvDetail.basic_info.lang;
        return item.length ? item[0][lang || 'cn'] : (degreeName || '')
      }
		},
		async mounted () {},
		methods: {
			// 是否显示添加按钮
			showAdd ({ type }) {
				return type !== 'personal_summary' && type !== 'skill_list' && type !== 'extras'
			},

      //修改模块排序-非extras
      sortModule(opt, sortType, index){
        let type = opt.type === "custom" ? opt.id : opt.type;
        let module = JSON.parse(JSON.stringify(this.$store.state.editor[type]));
        let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));
        //拿到当前模块数据
        let nowItem = module[index];
        if(sortType === 'up'){
          let nextItem = module[index-1];
          module.splice(index, 1, nextItem);
          module.splice(index-1, 1, nowItem);
        }else{
          let nextItem = module[index+1];
          module.splice(index, 1, nextItem);
          module.splice(index+1, 1, nowItem);
        }
        //拿到整理好之后的模块数据
        let moduleIds = module.map(item=>item.id);
        //整理相关模块的数据id
        if(type==="works" || type==='orgs' || type==='edus' || type==='opus'){
          cvDetail.submodule_info[type+'_ids'] = moduleIds;
        }else{
          //找到相关类型，修改id
          cvDetail.submodule_info.sections_position.forEach(item=>{
            if(item.type === type || item.id === type){
              item.info_ids = moduleIds;
              item.infos = moduleIds;
            }
          })
        }

        //修改之后的顺序同步到vuex中
        this.setModuleData({
          type,
          info: module
        });
        //同步操作之后的id到数据中
        this.setCvDetail(cvDetail);

        //防止重复提交接口
        clearTimeout(sortModuleTimeName)
        sortModuleTimeName = setTimeout(() => {
          console.log('保存')
          let payload = {
            operation_type: 'update_submodule_info',
            submodule_info: this.cvDetail.submodule_info
          }
          this.updateCvDetail(payload)
        }, 300);
      },
      //修改模块排序-extras
      sortExtrasModule(type, sortType, index){
        let extrasPosition = JSON.parse(JSON.stringify(this.extrasPosition))
        let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));

        console.log(type, sortType, index)
        //拿到当前模块数据
        let nowItem = extrasPosition[index];
        if(sortType === 'up'){
          let nextItem = extrasPosition[index-1];
          extrasPosition.splice(index, 1, nextItem);
          extrasPosition.splice(index-1, 1, nowItem);
        }else{
          let nextItem = extrasPosition[index+1];
          extrasPosition.splice(index, 1, nextItem);
          extrasPosition.splice(index+1, 1, nowItem);
        }
        extrasPosition.forEach((item,index)=>{
          extrasPosition[index] = item+'s'
        })
        cvDetail.submodule_info.extras_position = extrasPosition;
        //同步操作之后的id到数据中
        this.setCvDetail(cvDetail);

        //防止重复提交接口
        clearTimeout(sortModuleTimeName)
        sortModuleTimeName = setTimeout(() => {
          console.log('保存')
          let payload = {
            operation_type: 'update_submodule_info',
            submodule_info: this.cvDetail.submodule_info
          }
          this.updateCvDetail(payload)
        }, 300);
      },
		},
	}
</script>
<style lang="scss" scoped>
  // 公共初始化样式
  @import '~/assets/css/public';

  @import 'editor';
</style>
<style lang="scss">
  .item-desc {
    ul,
    ol {
      padding-left: 20px;
    }
  }
  .item-desc-wrapper {
    position: relative;
    .mask {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
</style>
